import './SkillsSection.css';
import windev from '../assets/images/windev.png';
import windev_mobile from '../assets/images/windev-mobile.png';
import webdev from '../assets/images/webdev.png';
import hfsql from '../assets/images/hfsql.png';

import {
  SiReact,
  SiTypescript,
  SiAngular,
  SiDjango,
  SiPhp,
  SiMysql,
} from 'react-icons/si';

import { DiMsqlServer } from 'react-icons/di';
import type { IconType } from 'react-icons';

type Skill =
  | {
      name: string;
      logo: string;
      type: 'image';
    }
  | {
      name: string;
      logo: IconType;
      type: 'icon';
    };

const skills: Skill[] = [
  { name: 'WinDev', logo: windev, type: 'image' },
  { name: 'WinDev Mobile', logo: windev_mobile, type: 'image' },
  { name: 'WebDev', logo: webdev, type: 'image' },
  { name: 'HFSQL', logo: hfsql, type: 'image' },

  { name: 'PHP', logo: SiPhp, type: 'icon' },
  { name: 'MySQL', logo: SiMysql, type: 'icon' },
  { name: 'SQL Server', logo: DiMsqlServer, type: 'icon' },

  { name: 'React', logo: SiReact, type: 'icon' },
  { name: 'TypeScript', logo: SiTypescript, type: 'icon' },
  { name: 'Angular', logo: SiAngular, type: 'icon' },
  { name: 'Django', logo: SiDjango, type: 'icon' },
];

function SkillsSection() {
  return (
    <section className="skills" id="competences">
      <div className="skills__panel section-card">
        <div className="section-heading">
          <span className="section-eyebrow">Compétences</span>
          <h2 className="section-title">Technologies</h2>
        </div>

        <div className="skills__tags-grid">
          {skills.map((skill) => (
            <div className="skills__tag-card" key={skill.name}>
              <div className="skills__tag-logo">
                {skill.type === 'icon' ? (
                  <skill.logo />
                ) : (
                  <img src={skill.logo} alt={skill.name} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SkillsSection;